import React from "react";
// REMOVE-ON-CLIENT-START
import ErrorFallBack from '@montana/vendor/react-ssr-error-boundary';
import { loadContext } from '@montana/vendor/react-ssr-error-boundary/server';
import { ReactReduxContext } from "react-redux";
// REMOVE-ON-CLIENT-END
import { isBrowser } from "@montana/helpers/browser.helper";
import { info } from "@montana/services/logger";
import { IPage, IBlock } from "@montana/models/generated/cms.interface";


type IDynamicErrorHandlerProps = Partial<IPage | IBlock>;

// REMOVE-ON-CLIENT-START
let contextEnsured = false;

const ensureContext = (): void => {
    if (!contextEnsured) {
        contextEnsured = true;
        loadContext(ReactReduxContext);
    }
};
// REMOVE-ON-CLIENT-END


export class DynamicErrorHandler extends React.Component<IDynamicErrorHandlerProps, { hasError: boolean; errorMessage: string }> {

    public readonly state = {
        hasError: false,
        errorMessage: "",
    };


    public static getDerivedStateFromError(error: Error): { hasError: boolean; errorMessage: string } {
        return { hasError: true, errorMessage: error.message };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        // TODO : add error to stacktrace
        if (isBrowser) {
            window.console.error(error, errorInfo);
        }
    }

    protected getErrorFallback(e?: Error): JSX.Element {
        const { kind, id } = this.props;

        if (e) {
            info(`Error rendering ${kind} (id: ${id}): ${e.message || e}`);
        }

        return (
            <div style={{ padding: '50px 20px', margin: '20px', color: 'red', border: '1px solid cyan' }}>
                <strong>
                    {kind}
                    &nbsp;is broken / misconfigured.&nbsp;
                </strong>
                <small>
                    ID:&nbsp;
                    {id}
                    &nbsp;/&nbsp;
                    {e ? e.message : this.state.errorMessage}
                </small>
            </div>
        );
    }


    public render(): JSX.Element | React.ReactNode {

        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return this.getErrorFallback();
        }

        if (isBrowser) {
            return children;
        }

        // REMOVE-ON-CLIENT-START
        ensureContext();

        return (
            // @ts-ignore
            <ErrorFallBack fallBack={(e: Error): JSX.Element => this.getErrorFallback(e)}>
                {children}
            </ErrorFallBack>
        );
        // REMOVE-ON-CLIENT-END
    }
}
